import { AdminRole } from "../../../types/admin";

export const roleOptions = [
    { value: AdminRole.admin, label: "Admin" },
    { value: AdminRole.master, label: "Master" },
    { value: AdminRole.normal, label: "Normal" },
    { value: AdminRole.creator, label: "Creator" },
  ];
  